// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_custom_day_category.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_custom_day_category.proto.
 */
export const file_bfftypes_v1_trading_custom_day_category: GenFile = /*@__PURE__*/
  fileDesc("Ci1iZmZ0eXBlcy92MS90cmFkaW5nX2N1c3RvbV9kYXlfY2F0ZWdvcnkucHJvdG8SC2JmZnR5cGVzLnYxKqECChhUcmFkaW5nQ3VzdG9tRGF5Q2F0ZWdvcnkSKwonVFJBRElOR19DVVNUT01fREFZX0NBVEVHT1JZX1VOU1BFQ0lGSUVEEAASJwojVFJBRElOR19DVVNUT01fREFZX0NBVEVHT1JZX1dFRUtEQVkQARInCiNUUkFESU5HX0NVU1RPTV9EQVlfQ0FURUdPUllfSE9MSURBWRACEigKJFRSQURJTkdfQ1VTVE9NX0RBWV9DQVRFR09SWV9BTExfREFZUxADIgQIBBAEIgQIBRAFKiRUUkFESU5HX0NVU1RPTV9EQVlfQ0FURUdPUllfU0FUVVJEQVkqKlRSQURJTkdfQ1VTVE9NX0RBWV9DQVRFR09SWV9TVU5EQVlfSE9MSURBWUJCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * TradingCustomDayCategory はカスタム (非定型) 時間帯 leg の適用日種別。
 * Mirrors backend types.v1.TradingCustomDayCategory 1:1 (wire 値も同一)。
 *
 * カスタム時間帯 leg は time_zone_type を未設定にして
 * custom_day_category + custom_time_slots で表す (= 標準時間帯 leg では
 * この enum は UNSPECIFIED)。
 *
 * @generated from enum bfftypes.v1.TradingCustomDayCategory
 */
export enum TradingCustomDayCategory {
  /**
   * @generated from enum value: TRADING_CUSTOM_DAY_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 平日 — 月〜金 (法定祝日を除く)。
   *
   * @generated from enum value: TRADING_CUSTOM_DAY_CATEGORY_WEEKDAY = 1;
   */
  WEEKDAY = 1,

  /**
   * 休日 — 土曜・日曜・祝日。
   *
   * @generated from enum value: TRADING_CUSTOM_DAY_CATEGORY_HOLIDAY = 2;
   */
  HOLIDAY = 2,

  /**
   * 全日 — 受渡期間内の全日。
   *
   * @generated from enum value: TRADING_CUSTOM_DAY_CATEGORY_ALL_DAYS = 3;
   */
  ALL_DAYS = 3,
}

/**
 * Describes the enum bfftypes.v1.TradingCustomDayCategory.
 */
export const TradingCustomDayCategorySchema: GenEnum<TradingCustomDayCategory> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_custom_day_category, 0);

